import { SearchRounded } from "@mui/icons-material";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import AlertSnackbar from "components/NotificationZone/Snackbars/AlertSnackbar";
import { INTERACTIVE_CLASSNAME_SUFFIX } from "components/WarehouseElements/Grid/InteractiveGridElement/InteractiveGridElement";
import { Severity } from "constants/Severity";
import { TestIds } from "constants/Tests/TestIds";
import { useAppDispatch, useAppSelector } from "hooks/StoreHooks";
import React, { useRef, useState } from "react";
import { useLazyGetElementContainerIdQuery } from "services/api/warehouseApi";
import { selectStoreNb } from "store/Selectors/locationsSelector";
import { getWarehousePlan } from "store/Selectors/warehousePlanSelector";
import { setSearchedItemId } from "store/Slices/gridEventSlice";
import { Shortcuts } from "./Shortcuts/Shortcuts";

import "./WarehouseSearchHeaders.scss";

const UNFOUND_ELEMENT_SNACKBAR_DURATION = 3 * 1000;

export default function WarehouseSearchZone() {
  const [isOpen, setOpen] = useState(false);
  const [message, setMessage] = useState({} as { text: string; severity: Severity });
  const inputFieldRef = useRef(null);

  const handleSnackbarClose = () => {
    setOpen(false);
  };

  const [searchedId, setSearchedId] = useState("");
  const storeNb = useAppSelector(selectStoreNb);
  const warehousePlan = useAppSelector(getWarehousePlan);

  const [onIdSearch] = useLazyGetElementContainerIdQuery();

  const dispatch = useAppDispatch();

  const onChangeSearchId = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    setSearchedId(e.target.value);
  };

  const handleIdSearch = async () => {
    const isIdInPlan = warehousePlan.plan?.elements.find(
      e => e.id.toUpperCase() == searchedId.toUpperCase()
    );
    if (isIdInPlan) {
      document
        .getElementsByClassName(
          `${searchedId.toUpperCase()}${INTERACTIVE_CLASSNAME_SUFFIX}`
        )[0]
        ?.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "center",
        });
      dispatch(setSearchedItemId(searchedId));
    } else {
      try {
        const containerId = await onIdSearch({
          elementId: searchedId,
          storeNb: storeNb,
        }).unwrap();
        const elem = document
          .getElementsByClassName(
            `${containerId.localisation.toUpperCase()}${INTERACTIVE_CLASSNAME_SUFFIX}`
          )[0]
        if (elem) {  
          document
            .getElementsByClassName(
              `${containerId.localisation.toUpperCase()}${INTERACTIVE_CLASSNAME_SUFFIX}`
            )[0]
            ?.scrollIntoView({
              behavior: "smooth",
              block: "center",
              inline: "center",
            });
          handleSnackbarClose;
          dispatch(setSearchedItemId(containerId.localisation));
        } else {
          if (containerId.texte) {
            setOpen(true);
            setMessage({ text: `${containerId.texte}`, severity: Severity.INFO });
          }
        }
      } catch (err) {
        setOpen(true);
        setMessage({ text: `L'élément ${searchedId} n'a pas été trouvé dans le plan.`, severity: Severity.WARNING });
      }
    }
  };
  return (
    <div className="warehouse-recherche-container mb-2">
      <Stack direction="row" spacing={2} className="warehouse-recherche-module">
        <TextField
          data-testid={TestIds.SEARCH_TXT_FIELD}
          ref={inputFieldRef}
          component={"form"}
          id={"ID"}
          label="Identifiant"
          type="search"
          value={searchedId}
          onChange={onChangeSearchId}
          onSubmit={(e: React.SyntheticEvent) => {
            e.preventDefault();
            handleIdSearch();
          }}
          size="small"
        />
        <Button
          type="button"
          variant="contained"
          size="small"
          startIcon={<SearchRounded />}
          onClick={handleIdSearch}
          style={{
            width: "100%",
          }}>
          Rechercher
        </Button>
      </Stack>
      <Shortcuts />
      <AlertSnackbar
        isOpen={isOpen}
        message={message.text}
        autoHideDuration={UNFOUND_ELEMENT_SNACKBAR_DURATION}
        severity={message.severity}
        onClose={handleSnackbarClose}
      />
    </div>
  );
}
